module.exports = __webpack_public_path__ + "img/discord-icon.8abbd39a.png";